/**
 * Recovery for on-demand chunks that vanished in a deploy. A tab opened before a release still
 * asks for the old hashed file names; the new deploy no longer has them, and the SPA fallback
 * answers with index.html, so the import fails. Reloading picks up the new build. The reload
 * happens once per tab session, so a chunk that is genuinely broken still surfaces its error
 * instead of looping.
 */
const KEY = 'chunk-reload'

export function reloadOnStaleChunk<T>(load: () => Promise<T>, reload = () => location.reload()) {
  return () =>
    load().then(
      (mod) => {
        try {
          sessionStorage.removeItem(KEY)
        } catch {
          // Storage blocked: nothing to clear.
        }
        return mod
      },
      (err: unknown) => {
        let reloaded = true
        try {
          reloaded = sessionStorage.getItem(KEY) !== null
          if (!reloaded) sessionStorage.setItem(KEY, '1')
        } catch {
          // Without storage we cannot tell a first failure from a loop, so do not reload.
        }
        if (reloaded) throw err
        reload()
        // Keep Suspense waiting while the page reloads.
        return new Promise<T>(() => {})
      },
    )
}
